import "./src/theme/index.scss"

const {
  SEO_MANAGED_ATTRIBUTE,
  SEO_MANAGED_VALUE,
  getPageMetadata,
  getStructuredData,
} = require("./src/seo/metadata")

const managedSelector = `[${SEO_MANAGED_ATTRIBUTE}="${SEO_MANAGED_VALUE}"]`

const appendManagedNode = (documentRef, tagName, attributes, textContent) => {
  const node = documentRef.createElement(tagName)

  node.setAttribute(SEO_MANAGED_ATTRIBUTE, SEO_MANAGED_VALUE)

  Object.entries(attributes).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      node.setAttribute(key, value)
    }
  })

  if (textContent) {
    node.text = textContent
  }

  documentRef.head.appendChild(node)
}

const syncMetadata = pathname => {
  if (typeof document === "undefined") {
    return
  }

  const metadata = getPageMetadata(pathname)

  document.documentElement.lang = "en"
  document.title = metadata.title

  document.head.querySelectorAll(managedSelector).forEach(node => {
    if (node.tagName.toLowerCase() !== "title") {
      node.remove()
    }
  })

  appendManagedNode(document, "meta", {
    name: "description",
    content: metadata.description,
  })
  appendManagedNode(document, "meta", {
    name: "robots",
    content: metadata.robots,
  })
  appendManagedNode(document, "link", {
    rel: "canonical",
    href: metadata.url,
  })
  appendManagedNode(document, "link", {
    rel: "alternate",
    hrefLang: "en",
    href: metadata.url,
  })
  appendManagedNode(document, "meta", {
    property: "og:locale",
    content: "en_US",
  })
  appendManagedNode(document, "meta", {
    property: "og:site_name",
    content: "Rate Cleaner",
  })
  appendManagedNode(document, "meta", {
    property: "og:type",
    content: metadata.type,
  })
  appendManagedNode(document, "meta", {
    property: "og:title",
    content: metadata.title,
  })
  appendManagedNode(document, "meta", {
    property: "og:description",
    content: metadata.description,
  })
  appendManagedNode(document, "meta", {
    property: "og:url",
    content: metadata.url,
  })
  appendManagedNode(document, "meta", {
    property: "og:image",
    content: metadata.image,
  })
  appendManagedNode(document, "meta", {
    property: "og:image:alt",
    content: metadata.title,
  })
  appendManagedNode(document, "meta", {
    name: "twitter:card",
    content: "summary_large_image",
  })
  appendManagedNode(document, "meta", {
    name: "twitter:title",
    content: metadata.title,
  })
  appendManagedNode(document, "meta", {
    name: "twitter:description",
    content: metadata.description,
  })
  appendManagedNode(document, "meta", {
    name: "twitter:image",
    content: metadata.image,
  })
  appendManagedNode(document, "meta", {
    name: "twitter:image:alt",
    content: metadata.title,
  })
  appendManagedNode(
    document,
    "script",
    {
      type: "application/ld+json",
    },
    JSON.stringify(getStructuredData(pathname))
  )
}

export const onInitialClientRender = () => {
  syncMetadata(window.location.pathname)
}

export const onRouteUpdate = ({ location }) => {
  syncMetadata(location.pathname)
}
